
import { Component, Vue } from 'vue-property-decorator';
import { UserId, UserModule } from '@/store/modules/user';
import { parseTime } from '../../utils';
import { taskImportList } from '@/api/taskImport';
import { syncQywxUser } from '@/api/users';
import dialogSetImport from '@/views/staff/components/setImport.vue'
@Component({
  name: 'FilesImportTask',
  filters: {
    formatDate(val: string) {
      if (val === '' || parseInt(val) === 0) {
        return '';
      }
      return parseTime(parseInt(val), '');
    }
  },
  components: {
    dialogSetImport
  }
})
export default class extends Vue {
  private tableData = []
  private timeCountId:any='';
  private detailImportVisible=false;
  private importBackData={};
  created() {
    this.taskImportList();
    if (!this.timeCountId) {
      this.timeCountId = setInterval(() => {
        this.taskImportList();
      }, 5000);
    }
    if (this.$route.query.is_qywx) {
      this.syncQywxUser();
      this.dialogSyncVisible = true;
      this.$notify.info({
        title: '企业微信同步',
        message: '正在同步，结束后可到查看同步记录中查看结果。',
        duration: 0
      });
    }
  }
  private taskImportList() {
    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.user_name = UserModule.getUserName;
    params.company_id = UserModule.getCompanyId;
    params.size = 200;
    taskImportList(params).then(res => {
      if (res.data) {
        this.tableData = res.data.list;
      } else {
        this.tableData = [];
      }
    }).catch(err => {
      clearInterval(this.timeCountId);
      let msg = err.msg;
    });
  }

  private detailsHandle(val: any) {
    this.detailImportVisible = true;
    this.importBackData = val;
  }
  destroyed() {
    clearInterval(this.timeCountId);
  }

  // 企业微信同步
   private setImportVisible = false
  private setImportType=9
  private setImportTitle='导入人员'
  closeImport(value: boolean) {
    this.setImportVisible = value;
  }
  private QyFinish(data:any) {
    if (parseInt(data.state) === 4) {
      this.isFirst = false;
      this.isSecond = false;
      this.isThird = true;
      this.dataPercent = 85;
      setTimeout(() => {
        this.dialogSyncVisible = false;
        this.dataPercent = 100;
      }, 1500);
    }
  }
  private QyFail(err:any) {
    this.showErrorMsg(err.msg);
  }
  private state:any=0;
  private number:any='';
  private progressMessage='';
  private syncQywxUser() {
    let pamars:any = {
      company_id: UserModule.getCompanyId,
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_name: UserModule.getCompanyName,
      auto_login: 0,
      state: this.state,
      number: this.number
    };
    syncQywxUser(pamars).then((res:any) => {
      if (res.data) {
        this.state = res.data.state;
        this.number = res.data.number;
        this.progressMessage = res.data.progress_message;
        if (parseInt(res.data.state) >= 5) {
          this.showSecussMsg(res.msg);
          return;
        }
        if (parseInt(res.data.state) >= 3 && res.data.url) {
          this.downLoadUrl = res.data.url;
          this.dataPercent = 50;
          this.isFirst = false;
          this.isSecond = true;
          this.isThird = false;
        } else {
          setTimeout(() => {
            this.syncQywxUser();
          }, 3000);
        }
      }
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private downLoad() {
    window.open(this.downLoadUrl);
  }
  private upLoadQy() {
    this.setImportVisible = true;
  }
  private handleSync(row:any) {
    this.syncQywxUser();
    this.dialogSyncVisible = true;
  }
  private dialogSyncVisible = false;
  private dataPercent = 30
  private downLoadUrl=''
  private isFirst = true
  private isSecond = false
  private isThird = false

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }
}
